export const currentUserFormModalId = 'currentUserFormModalId';
export const currentUserEmailFormModalId = 'currentUserEmailFormModalId';

export const currentUserPasswordModalId = 'currentUserPasswordModalId';
export const currentUserAlertId = 'currentUserAlert';
export const totpModalEnableId = 'totpModalEnabledId';
export const totpModalDisableId = 'totpModalDisableId';
